import * as React from 'react';
import PropTypes from 'prop-types';

class FilterGroup extends React.Component {
	constructor(){
		super();
		this.onYear = this.onYear.bind(this);
		this.onTag = this.onTag.bind(this);
	}

	onYear(year) {
		this.props.onYear(year);
	}

	onTag(tag) {
		this.props.onTag(tag);
	}

	render() {
		var tags = this.props.tags
			.map((t, i) => <li key={t.key}><a onClick={this.onTag.bind(this, t.value)}>{t.key}</a></li>);

		var years = this.props.years
			.map((y, i) => <li key={y}><a onClick={this.onYear.bind(this, y)}>{y}</a></li>);

		return (
			<div className="comp__filter-group">
				<div className="comp__filter">
					<a className="button button-dropdown tiny" data-dropdown="autoClose-02" aria-controls="autoClose-02" aria-expanded="false">
						{this.props.yearHeader}
					</a>
					<ul id="autoClose-02" className="f-dropdown comp__dropdown" data-dropdown-content tabIndex="-1" aria-hidden="true">
						{years}
					</ul>
				</div>
				<div className="comp__filter">
					<a className="button button-dropdown tiny" data-dropdown="autoClose-03" aria-controls="autoClose-03" aria-expanded="false">
						{this.props.tagHeader}
					</a>
					<ul id="autoClose-03" className="f-dropdown comp__dropdown" data-dropdown-content tabIndex="-1" aria-hidden="true">
						{tags}
					</ul>
				</div>
			</div>
		);
	}
}

FilterGroup.propsTypes = {
	years: PropTypes.array.isRequired,
	tags: PropTypes.array.isRequired,
	yearHeader: PropTypes.string.isRequired,
	tagHeader: PropTypes.string.isRequired
};

FilterGroup.defaultProps = {
	years: [],
	tags: [],
	yearHeader: '',
	tagHeader: ''
};

export default FilterGroup;


// WEBPACK FOOTER //
// ./app/js/module/filtergroup.jsx